import { isMatch, useMatches } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface BreadcrumbItem {
  id: string;
  label: string;
  to: string;
  params: object;
  isActive: boolean;
}

export function useBreadcrumbs(): BreadcrumbItem[] {
  const { t } = useTranslation();
  const matches = useMatches();
  if (matches.some(match => match.status === 'pending')) return [];

  const matchesWithCrumbs = matches.filter(
    // @ts-expect-error weird type
    match => isMatch(match, 'staticData.pageTitle') || isMatch(match, 'loaderData.crumb'),
    // eslint-disable-next-line
  ) as any[];

  if (matchesWithCrumbs.length == 0) return [];

  return matchesWithCrumbs.map((item, index) => ({
    id: item.id,
    to: item.fullPath,
    params: item.params,
    label: item.staticData?.pageTitle?.id ? t(item.staticData.pageTitle.id) : (item.loaderData?.crumb ?? '-'),
    isActive: index == matchesWithCrumbs.length - 1,
  }));
}

export function useDerivePageTitle() {
  const titleSuffix = 'Arena';
  const breadcrumbs = useBreadcrumbs();

  const items = [...breadcrumbs].reverse();

  useEffect(() => {
    const name = items
      .map(section => section.label)
      .filter(section => section != null)
      .join(' | ');
    document.title = name ? `${name} | ${titleSuffix}` : titleSuffix;
  }, [items, titleSuffix]);
}
